import Vue from 'vue';
import Vuex from 'vuex';
import authentication from './modules/authentication';
import broker from './modules/broker';
import brokers from './modules/brokers';
import application from './modules/application';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    authentication,
    broker,
    brokers,
    application,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js